"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Back4app2Error_1 = require("./Back4app2Error");
/**
 * A deployment stopped because the code analyzer judged the project abusive.
 *
 * Deliberately not a reuse of BlockedResourceError: that one is also thrown
 * for blocked GitHub repositories and for every legacy manual block, and its
 * message says "contact our supporting team" — which is the flood this design
 * exists to avoid. A distinct code lets the dashboard render the appeal form
 * for analyzer blocks and nothing else.
 *
 * The message reaching the customer names policy categories at most. Never a
 * file, a line, a pattern or the reasoning: an abuser must not learn what to
 * rename.
 */
var SecurityBlockError = /** @class */ (function (_super) {
    __extends(SecurityBlockError, _super);
    function SecurityBlockError(message) {
        var _this = _super.call(this, message, SecurityBlockError.CODE) || this;
        Object.setPrototypeOf(_this, SecurityBlockError.prototype);
        return _this;
    }
    SecurityBlockError.CODE = 'SECURITY_BLOCK_ERROR';
    return SecurityBlockError;
}(Back4app2Error_1.default));
exports.default = SecurityBlockError;
